const normalize = (value) => String(value || "").trim().toLowerCase();

export function productMatchesSearch(product, query) {
  const search = normalize(query);
  return [product.name, product.barcode,
    ...(product.units || []).map((unit) => unit.barcode),
    ...(product.variants || []).map((variant) => variant.barcode),
  ].some((value) => normalize(value).includes(search));
}

// Return all matches so duplicate codes never silently select the wrong unit.
export function productCodeMatches(product, query) {
  const code = normalize(query);
  if (!code) return [];
  const matches = [];
  if (normalize(product.barcode) === code) matches.push({ product });
  for (const unit of product.units || []) {
    if (normalize(unit.barcode) === code) matches.push({ product, unit });
  }
  for (const variant of product.variants || []) {
    if (normalize(variant.barcode) === code) matches.push({ product, variant });
  }
  return matches;
}
